<xemex-time-controls
  [options]="chartRangeOptions"
  [selected]="telemetryStore.range()"
  [initialDate]="initialDate"
  [framed]="true"
  (selectedChange)="onChartRangeChanged($event)"
  (periodChange)="onPeriodChanged($event)"
></xemex-time-controls>
